import { Injectable } from "@angular/core";

import { CommonState } from "../../state";

import { ZhhSessionLimitState } from "./zhh-session-limit.model";

@Injectable({
	providedIn: "root",
})
export class ZhhSessionLimitSelector {
	getZhhSessionLimit() {
		return (state: CommonState): ZhhSessionLimitState | undefined => state.zhhSessionLimit;
	}
}
